var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronUpYellow16Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "11px",
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "18A7CC02-C087-497D-BCFC-05E316D85A08_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    transform: "matrix(1 0 0 -1 0 10.707)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-1176,-327)",
    stroke: "#ffcd00",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,224)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,61)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(930)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Icon_Chevron-Down_Yellow-16px",
    points: "39 43 47 51 55 43"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronUpYellow16Px);
export default __webpack_public_path__ + "static/media/Icon_Chevron-Up_Yellow-16px.d317a37d093c8b6b14b3c04d89e3c005.svg";
export { ForwardRef as ReactComponent };